module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "package-detail"
  }, [_c('div', {
    staticClass: "custom-tabs"
  }, [_c('div', {
    staticClass: "tab-header"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      key: tab.name,
      class: ['tab-item', {
        'active': _vm.activeTab === tab.name
      }],
      on: {
        "click": function($event) {
          return _vm.handleTabClick(tab.name)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(tab.label) + " (" + _vm._s(_vm.totalCounts[tab.name]) + ")")])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "material-list"
  }, [(_vm.activeTab === 'scene') ? _c('div', {
    staticClass: "scene-list"
  }, _vm._l((_vm.currentList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "package_detail_scene"
    }, [_c('div', {
      staticClass: "pic"
    }, [(!item.thumb) ? _c('img', {
      attrs: {
        "src": require("../HomePage/conver_scene_horizontal.png")
      }
    }) : _vm._e(), _vm._v(" "), (item.thumb) ? _c('img', {
      staticClass: "item-img",
      attrs: {
        "src": item.thumb
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.copyright))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'material') ? _c('div', {
    staticClass: "material-list-content"
  }, _vm._l((_vm.currentList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "package_detail_material"
    }, [_c('div', {
      staticClass: "pic"
    }, [(!item.thumb) ? _c('img', {
      attrs: {
        "src": require("../HomePage/conver_material_vertical.png")
      }
    }) : _vm._e(), _vm._v(" "), (item.thumb) ? _c('img', {
      staticClass: "item-img",
      attrs: {
        "src": item.thumb
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.title.length > 9 ? item.title.substring(0, 9) + '...' : item.title))]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.copyright))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'prop') ? _c('div', {
    staticClass: "prop-list"
  }, _vm._l((_vm.currentList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "package_detail_prop"
    }, [_c('div', {
      staticClass: "pic"
    }, [(!item.thumb) ? _c('img', {
      attrs: {
        "src": require("../HomePage/conver_material_vertical.png")
      }
    }) : _vm._e(), _vm._v(" "), (item.thumb) ? _c('img', {
      staticClass: "item-img",
      attrs: {
        "src": item.thumb
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.title.length > 10 ? item.title.substring(0, 9) + '...' : item.title))]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.copyright))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'bgm') ? _c('div', {
    staticClass: "bgm-list"
  }, _vm._l((_vm.currentList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "package_detail_bgm"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.title.length > 10 ? item.title.substring(0, 9) + '...' : item.title))]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.copyright))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'action') ? _c('div', {
    staticClass: "action-list"
  }, _vm._l((_vm.currentList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "package_detail_action"
    }, [_c('div', [_vm._v(_vm._s(item.title.length > 13 ? item.title.substring(0, 13) + '...' : item.title))]), _vm._v(" "), (item.extdata && item.extdata.movable !== null) ? _c('div', [(item.extdata.movable && item.extdata.looped) ? _c('i', {
      staticClass: "icon-action_move"
    }) : _vm._e(), _vm._v(" "), (item.extdata.looped && !item.extdata.movable) ? _c('i', {
      staticClass: "icon-action_circulation"
    }) : _vm._e(), _vm._v(" "), (!item.extdata.movable || !item.extdata.looped) ? _c('i', {
      staticClass: "icon-action_time"
    }) : _vm._e(), _vm._v(" "), (!item.extdata.movable || !item.extdata.looped) ? _c('span', [_vm._v(_vm._s(item.extdata.duration.toFixed(2)) + "秒")]) : _vm._e()]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.currentList.length === 0 && !_vm.loading) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('p', [_vm._v("暂无" + _vm._s(_vm.getTabName(_vm.activeTab)) + "素材")])]) : _vm._e()]), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "pager-count": 5,
      "layout": "total, sizes, prev, pager, next, jumper",
      "size": "small"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("../HomePage/music.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f38860d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PackageDetail/PackageDetail.vue
// module id = 389
// module chunks = 0